export default {
  odersCustomer: {},
  odersCustomerId: 0
}
